var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","return-object":"","item-text":"name","items":_vm.typeList,"label":_vm.$t('maintenanceTask.type'),"prepend-inner-icon":"mdi-progress-check"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }